import React from 'react';

const PlanContext = React.createContext([]);

export default PlanContext;
